import type { ReactNode } from "react";
import type { PreviewDeviceMode } from "../types";

export function PreviewShell({
  device,
  children,
  mobileFrame = true,
}: {
  device: PreviewDeviceMode;
  children: ReactNode;
  mobileFrame?: boolean;
}) {
  if (device === "desktop") {
    return (
      <div className="w-full max-w-[420px] bg-white rounded-xl shadow-lg overflow-hidden">
        {children}
      </div>
    );
  }
  if (!mobileFrame) {
    return (
      <div className="w-[300px] bg-white rounded-3xl shadow-lg overflow-hidden">{children}</div>
    );
  }
  return (
    <div className="w-[300px] rounded-[2rem] border-[10px] border-black/80 bg-black overflow-hidden shadow-2xl">
      <div className="bg-white">{children}</div>
    </div>
  );
}

export function MediaSlot({
  mediaUrl,
  mediaType,
  aspect = "aspect-square",
  fallback,
  bgClass = "bg-gray-100",
}: {
  mediaUrl?: string;
  mediaType?: "image" | "video";
  aspect?: string;
  fallback?: ReactNode;
  bgClass?: string;
}) {
  if (!mediaUrl) {
    return (
      <div className={`w-full ${aspect} ${bgClass} flex items-center justify-center`}>
        {fallback}
      </div>
    );
  }
  return (
    <div className={`w-full ${aspect} ${bgClass} overflow-hidden`}>
      {mediaType === "video" ? (
        <video src={mediaUrl} className="w-full h-full object-cover" muted playsInline />
      ) : (
        <img
          src={mediaUrl}
          alt=""
          className="w-full h-full object-cover"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
          }}
        />
      )}
    </div>
  );
}
